export default __webpack_public_path__ + "static/media/Coffee Beans Cover Pic.de463827.png";